import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-02c550e2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "interview-home"
};
const _hoisted_2 = {
  class: "category-group-top"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "category-group-spacer"
}, null, -1));
const _hoisted_5 = {
  class: "card-grid"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "card-icon"
};
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = {
  class: "card-title"
};
const _hoisted_11 = {
  class: "card-desc"
};
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { articleItem } from "@/models/article";
import { SysDictDataControllerService } from "../../generated";
import myAxios from "@/plugins/myAxios";

// SVG 图标

export default {
  __name: 'InterviewHomeView',
  setup(__props) {
    const icons = {
      backend: `<svg width="24" height="24" fill="none" viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="3" fill="#1976d2" fill-opacity=".15"/><rect x="7" y="9" width="10" height="6" rx="2" fill="#1976d2"/></svg>`,
      frontend: `<svg width="24" height="24" fill="none" viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="3" fill="#1976d2" fill-opacity=".15"/><rect x="6" y="8" width="12" height="8" rx="2" fill="#42b983"/></svg>`,
      security: `<svg width="24" height="24" fill="none" viewBox="0 0 24 24"><path d="M12 3l7 4v5c0 5-3.5 9-7 9s-7-4-7-9V7l7-4z" fill="#1976d2" fill-opacity=".15"/><path d="M12 3v17" stroke="#1976d2" stroke-width="2"/></svg>`,
      java: `<svg width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#f89820" fill-opacity=".15"/><path d="M8 16c2 1.5 6 1.5 8 0" stroke="#f89820" stroke-width="2"/></svg>`,
      db: `<svg width="24" height="24" fill="none" viewBox="0 0 24 24"><ellipse cx="12" cy="7" rx="7" ry="3" fill="#1976d2" fill-opacity=".15"/><ellipse cx="12" cy="17" rx="7" ry="3" fill="#1976d2" fill-opacity=".15"/><rect x="5" y="7" width="14" height="10" rx="3" fill="#1976d2"/></svg>`,
      spring: `<svg width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#6db33f" fill-opacity=".15"/><path d="M8 12c2-2 6-2 8 0" stroke="#6db33f" stroke-width="2"/></svg>`,
      js: `<svg width="24" height="24" fill="none" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="4" fill="#f7df1e" fill-opacity=".15"/><text x="7" y="17" font-size="8" fill="#f7df1e">JS</text></svg>`,
      vue: `<svg width="24" height="24" fill="none" viewBox="0 0 24 24"><polygon points="12,4 20,20 4,20" fill="#42b983" fill-opacity=".15"/><polygon points="12,8 17,20 7,20" fill="#42b983"/></svg>`,
      css: `<svg width="24" height="24" fill="none" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="4" fill="#1976d2" fill-opacity=".15"/><text x="7" y="17" font-size="8" fill="#1976d2">CSS</text></svg>`,
      websec: `<svg width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#1976d2" fill-opacity=".15"/><path d="M8 12a4 4 0 1 0 8 0" stroke="#1976d2" stroke-width="2"/></svg>`,
      net: `<svg width="24" height="24" fill="none" viewBox="0 0 24 24"><rect x="4" y="8" width="16" height="8" rx="4" fill="#1976d2" fill-opacity=".15"/><path d="M4 12h16" stroke="#1976d2" stroke-width="2"/></svg>`
    };

    // 获取随机图标
    const getRandomIcon = () => {
      const iconKeys = Object.keys(icons);
      const randomKey = iconKeys[Math.floor(Math.random() * iconKeys.length)];
      return icons[randomKey];
    };
    const categories = ref([]);
    const selectedCategory = ref();

    // 获取标签类别
    const getSysDicType = async () => {
      try {
        //获取字典数据
        const res = await SysDictDataControllerService.dictTypeUsingGet('interview_tag');
        if (res && res.data) {
          // 转换数据格式
          const formattedData = res.data.map(item => ({
            key: item.dictValue,
            label: item.dictLabel
          }));
          categories.value = formattedData;
          // 如果有数据，默认选中第一项
          if (formattedData.length > 0) {
            selectedCategory.value = formattedData[0].key;
          }
        }
      } catch (error) {
        console.error('获取面试题标签失败:', error);
        // 设置默认分类，以防接口调用失败
        // categories.value = [
        //   { key: 'backend', label: '后端' },
        //   { key: 'frontend', label: '前端' },
        //   { key: 'security', label: '网络安全' },
        // ];
        // selectedCategory.value = 'backend';
      }
    };

    // 子主题数据
    const subTopics = ref([]);

    // 获取面试题分类数据
    const getInterViewProfileData = async () => {
      try {
        const res = await myAxios.get('/baseinfo/fronted/getAllInterViewProfiles');
        if (res.data.code === 200) {
          // 处理返回的数据，添加图标
          const processedData = res.data.data.map(item => ({
            key: item.id,
            title: item.name,
            desc: item.detail,
            category: item.tag,
            icon: item.image
          }));
          subTopics.value = processedData;
          // console.log(subTopics.value);
        } else {
          console.warn('获取面试题分类数据失败:', res.msg);
        }
      } catch (error) {
        console.error('获取面试题分类数据出错:', error);
      }
    };
    // subTopics.value = [
    //   {key: 'java-basic', category: 'backend', title: 'Java基础', desc: 'Java语法、面向对象、常用API', icon: icons.java},
    //   {key: 'db', category: 'backend', title: '数据库', desc: 'MySQL、Redis、事务、索引', icon: icons.db},
    //   {key: 'spring', category: 'backend', title: 'Spring框架', desc: 'IOC、AOP、SpringBoot', icon: icons.spring},
    //   {key: 'js-basic', category: 'frontend', title: 'JavaScript基础', desc: 'ES6、闭包、原型链', icon: icons.js},
    //   {key: 'vue', category: 'frontend', title: 'Vue', desc: '响应式、组件、生命周期', icon: icons.vue},
    //   {key: 'css', category: 'frontend', title: 'CSS', desc: '布局、动画、BFC', icon: icons.css},
    //   {key: 'web-sec', category: 'security', title: 'Web安全', desc: 'XSS、CSRF、SQL注入', icon: icons.websec},
    //   {key: 'net-protocol', category: 'security', title: '网络协议', desc: 'TCP/IP、HTTPS、抓包', icon: icons.net},
    // ];

    // 在组件挂载时获取数据
    onMounted(() => {
      getSysDicType(); // 获取标签类别数据
      getInterViewProfileData(); //获取子主题的mock数据
    });

    // 过滤子主题
    const filteredSubTopics = computed(() => subTopics.value.filter(s => s.category === parseInt(selectedCategory.value)));
    const router = useRouter();
    function selectCategory(key) {
      selectedCategory.value = key;
    }
    function goToSubTopic(sub) {
      // 跳转到题目列表页面，带子主题key参数（已实现联动）
      router.push(`/business/interview/detail/${sub.key}/${sub.title}`);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, cat => {
        return _openBlock(), _createElementBlock("button", {
          key: cat.key,
          class: _normalizeClass(['category-btn', {
            active: cat.key === selectedCategory.value
          }]),
          onClick: $event => selectCategory(cat.key)
        }, _toDisplayString(cat.label), 11, _hoisted_3);
      }), 128))]), _hoisted_4, _createElementVNode("main", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSubTopics.value, sub => {
        return _openBlock(), _createElementBlock("div", {
          key: sub.key,
          class: "subtopic-card",
          onClick: $event => goToSubTopic(sub)
        }, [_createElementVNode("div", _hoisted_7, [sub.icon ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: sub.icon,
          alt: sub.title,
          class: "icon-image"
        }, null, 8, _hoisted_8)) : (_openBlock(), _createElementBlock("span", {
          key: 1,
          innerHTML: getRandomIcon(),
          class: "icon-svg"
        }, null, 8, _hoisted_9))]), _createElementVNode("div", _hoisted_10, _toDisplayString(sub.title), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(sub.desc), 1)], 8, _hoisted_6);
      }), 128))])]);
    };
  }
};